import axios from 'axios'
import Vue from 'vue'
import router from '@/router'

const service = axios.create({
    baseURL: '',
    timeout: 10 * 1000
})

service.interceptors.request.use(config => {
    config.data = JSON.stringify(config.data)
    config.headers = {
        'Content-Type': 'application/json;charset=UTF-8'
    }
    return config
})

service.interceptors.response.use(response => {
    var data = null
    if (response.headers['content-type'] === 'application/json;charset=UTF-8') {
        data = response.data
        if (data.code === 'UNLOGIN') {
            // Vue.prototype.$alert(data.desc, {
            //     callback: action => {
            //         router.replace('/login')
            //     }
            // })
            router.replace('/login')
            Vue.prototype.$message({
                title: '重新登录',
                message: data.desc,
                type: 'error',
                dangerouslyUseHTMLString: true,
                center: true
            })
            // return
        }
    } else {
        data = response
    }
    return data
},
error => {
    console.log(error.status)
    // console.log(JSON.stringify(error))
    if (error.status !== 200) {
        Vue.prototype.$alert('请求处理失败！')
        return false
    }
})

Vue.prototype.$axios = axios

export default service



// WEBPACK FOOTER //
// ./src/util/request.js